import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=3f7b14d9&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b14d9",
  null
  
)

export default component.exports